// FAQ SECTION ********************************          
$(window).on("load", function() {           



   $("#FAQSection .faq").click(function() { 
      
      if (!$(this).hasClass("acitve")) { 
         
         var pheight = $(this).find(".faqbody p").height();

         $("#FAQSection .faq.active .faqbody").css({"height": 0 });
         $("#FAQSection .faq.active").find("h3 span.open").text("+");
         $("#FAQSection .faq.active").removeClass("active");

         $(this).addClass("active").find("h3 span.open").text("-");
         $("#FAQSection .faq.active .faqbody").css({"height": pheight + 30 });

      }

   });



});  